export class WrongValidatorSettingError extends Error {
  name = 'WrongValidatorSettingError'
  message = 'Wrong Validator Setting'
}
